export default {
  GET_GLOBAL_TRACKING_QUERY: Symbol.for('GET_GLOBAL_TRACKING_QUERY'),
  GLOBAL_TRACKING_REPOSITORY: Symbol.for('GLOBAL_TRACKING_REPOSITORY'),
  GLOBAL_TRACKING_STATE_MANAGER: Symbol.for('GLOBAL_TRACKING_STATE_MANAGER'),
};
